import validate from "/codebuild/output/src2808178616/src/web-front-end/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/codebuild/output/src2808178616/src/web-front-end/middleware/auth.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global
]
export const namedMiddleware = {}